import { useEffect, useRef } from 'react';
import { ChevronDown } from 'lucide-react';
import Icon from '@/components/primitives/Icon.jsx';
import ExecutionStatus from '@/components/surfaces/ExecutionStatus.jsx';
import formatRunDuration from '../lib/formatRunDuration.js';
import formatRunTime from '../lib/formatRunTime.js';
import resolveRunExecutionState from '../lib/resolveRunExecutionState.js';
import ConversationRunDetails from './ConversationRunDetails.jsx';
import WorkflowRunDetails from './WorkflowRunDetails.jsx';

/** One run in the history: when it ran, how it went and how long it took; opens to its steps and result. The run a
   link names (`linked`) scrolls into view once. */
const AutomationRunItem = ({ run, workflowId, open, linked = false, onToggle }) => {
  const itemRef = useRef(null);

  useEffect(() => {
    if (linked) {
      itemRef.current?.scrollIntoView?.({ block: 'start' });
    }
  }, [linked]);

  const { state, detail } = resolveRunExecutionState(run.status);
  const isLive = state === 'running' || state === 'queued';
  const duration = formatRunDuration(run.startedAt, run.finishedAt);
  const panelId = `run-${run.id}`;

  return (
    <li ref={itemRef} className="automations-run" data-open={open ? 'true' : undefined}>
      <button type="button" className="automations-run__summary" aria-expanded={open} aria-controls={panelId} onClick={onToggle}>
        <span className="automations-run__time">{formatRunTime(run.startedAt)}</span>
        <ExecutionStatus state={state} detail={detail} size="sm" />
        <span className="automations-run__duration">{duration}</span>
        <span className="automations-run__chevron">
          <Icon icon={ChevronDown} />
        </span>
      </button>
      {open && (
        <div id={panelId} className="automations-run__panel">
          {run.error && <p className="automations-run__error">{run.error}</p>}
          {run.workflowRunId ? <WorkflowRunDetails workflowId={workflowId} workflowRunId={run.workflowRunId} isLive={isLive} /> : <ConversationRunDetails threadId={run.threadId} isLive={isLive} />}
        </div>
      )}
    </li>
  );
};

export default AutomationRunItem;
